import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { EssClientLogger } from 'typeahead-client-logger';
import { Origin } from './origin';
import { SearchFormFieldProps } from 'components/common/search-form';

interface OriginWrapperProps extends SearchFormFieldProps {
  essAnalyticsLogger?: EssClientLogger;
}

export class OriginWrapper extends React.Component<OriginWrapperProps> {
  render() {
    return (
      <Experiment name="Optimize_Number_Of_Typeahead_Suggestion">
        <ExperimentControl>
          <Origin {...this.props} maxTypeaheadResults={10} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <Origin {...this.props} maxTypeaheadResults={5} />
        </ExperimentVariant>
        <ExperimentVariant bucket={2}>
          <Origin {...this.props} maxTypeaheadResults={6} />
        </ExperimentVariant>
      </Experiment>
    );
  }
}
